<template>
  <div class="wrapper p-3 mb-5">
    <div
      block
      v-b-toggle.filter-work-order
      class="text-decoration-none"
      @click="isOpen = !isOpen"
    >
      <b>Filter</b>
      <fa-icon
        class="ml-2"
        :icon="isOpen ? 'caret-down' : 'caret-right'"
      />
    </div>
    <b-collapse
      id="filter-work-order"
    >
      <b-row class="mt-3" align-v="center">
        <b-col>
          <b-form-group
            label="Contractor Name"
            label-size="sm"
          >
            <v-select
              label="name"
              v-model="filterData.contractor_name"
              placeholder="Select Contractor Name"
              :options="options.contractor_name"
              :reduce="({ id }) => id"
              @input="$emit('apply')"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Contract Number"
            label-size="sm"
          >
            <b-form-input
              autocapitalize="off"
              v-model="filterData.contract_number"
              placeholder="Enter Contract Number"
              size="sm"
              @change="$emit('apply')"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Payment Period"
            label-size="sm"
          >
            <b-form-input
              v-model="filterData.payment_period"
              type="month"
              size="sm"
              @change="$emit('apply')"
            />
          </b-form-group>
        </b-col>
        <div class="w-100"></div>
        <b-col>
          <b-form-group
            label="Work Order Number"
            label-size="sm"
          >
            <b-form-input
              autocapitalize="off"
              v-model="filterData.wo_number"
              placeholder="Enter Work Order Number"
              size="sm"
              @change="$emit('apply')"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Department"
            label-size="sm"
          >
            <v-select
              label="name"
              v-model="filterData.department"
              placeholder="Select Department"
              :options="options.department"
              :reduce="({ id }) => id"
              @input="$emit('apply')"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Job Desc"
            label-size="sm"
          >
            <b-form-input
              autocapitalize="off"
              v-model="filterData.job_desc"
              placeholder="Enter Job Desc"
              size="sm"
              @change="$emit('apply')"
            />
          </b-form-group>
        </b-col>
        <div class="w-100"></div>
        <b-col>
          <b-form-group
            label="Budget Code"
            label-size="sm"
          >
            <b-form-input
              autocapitalize="off"
              v-model="filterData.budget_code"
              placeholder="Enter Budget Code"
              size="sm"
              @change="$emit('apply')"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Status"
            label-size="sm"
          >
            <v-select
              v-model="filterData.status"
              placeholder="Select Status"
              :options="options.status"
              @input="$emit('apply')"
            />
          </b-form-group>
        </b-col>
        <b-col>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          class="btn-custom"
          variant="info"
          size="sm"
          @click="$emit('reset')"
        >
          Reset
        </b-button>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import api from '@/api'

export default {
  props: {
    filterData: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    options: {
      department: [],
      status: [],
      contractor_name: []
    },
    isOpen: false
  }),
  mounted() {
    this.fetchFilter()
  },
  methods: {
    async fetchFilter() {
      try {
        Object.keys(this.options).map(async v => {
          let data = null
          if (v === 'department') {
            data = await api.department.list()
          }
          if (v === 'status') {
            data = await api.summaryProgress.status()
          }
          if (v === 'contractor_name') {
            data = await api.contractor.list()
          }

          this.options[v] = data
        })
      } catch (error) {}
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  background-color: #DBF9F6;
  border-radius: 16px;
}
</style>
